import { format } from "date-fns";

export const formatCurrency = (amount: number, currency: string = "gbp"): string => {
  const currencySymbols: Record<string, string> = {
    gbp: "£",
    usd: "$",
    eur: "€",
  };

  const symbol = currencySymbols[currency.toLowerCase()] || currency.toUpperCase();
  const value = (amount / 100).toFixed(2);
  return `${symbol}${value}`;
};

export const formatDate = (date: string): string => {
  return format(new Date(date), "MMM d, yyyy");
};

export const formatDateTime = (date: string): string => {
  return format(new Date(date), "MMM d, yyyy h:mm a");
};

export const formatStatus = (status: string): string => {
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const getStatusColor = (status: string): string => {
  switch (status) {
    case "succeeded":
      return "bg-green-100 text-green-800";
    case "pending":
      return "bg-yellow-100 text-yellow-800";
    case "failed":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};
